/* eslint-disable import/first */
import React from 'react';

export default function AddressPin(props) {
  return (
    <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.57862 15.2332L11.4269 20.8165L17.2751 15.2332C20.505 12.1496 20.505 7.15014 17.2751 4.06658C14.0452 0.983015 8.80855 0.983015 5.57867 4.06658C2.34879 7.15014 2.34877 12.1496 5.57862 15.2332ZM15.9757 13.9925L11.4269 18.3353L6.87801 13.9925C4.36606 11.5941 4.3662 7.70571 6.87832 5.30747C9.39043 2.90923 13.4633 2.90923 15.9754 5.30747C18.4875 7.70571 18.4876 11.5941 15.9757 13.9925ZM11.4268 11.4048C12.4418 11.4048 13.2647 10.6193 13.2647 9.65017C13.2647 8.6811 12.4418 7.89551 11.4268 7.89551C10.4117 7.89551 9.58887 8.6811 9.58887 9.65017C9.58887 10.6193 10.4117 11.4048 11.4268 11.4048ZM7.75146 9.64996C7.75146 11.5881 9.39718 13.1593 11.4273 13.1593C13.4574 13.1593 15.1031 11.5881 15.1031 9.64996C15.1031 7.71181 13.4574 6.14062 11.4273 6.14062C9.39718 6.14062 7.75146 7.71181 7.75146 9.64996Z"
        fill="#393F52"
      />
    </svg>
  );
}
